

<h2 style="font-size:1.6em;">Ingen tilgang</h2>
<p>Beklager, men du har ikke tilgang til denne saken. Logg ut eller gå til sakslisten hvis du har andre saker.</p>
<p><span style="cursor: pointer" (click)="logout()">Trykk her for å logge ut</span></p>


